import { Button } from '@mui/material';
import { InfoDialogConfig } from '../../stores/dialogStore';
import { BaseDialog } from './BaseDialog';

interface InfoDialogProps {
  config: InfoDialogConfig;
  onClose: () => void;
}

export default function InfoDialog({ config, onClose }: InfoDialogProps) {
  const handleActionClick = (actionOnClick: () => void) => {
    actionOnClick();
    onClose();
  };

  const dialogActions = config.actions ? (
    config.actions.map((action) => (
      <Button
        key={action.text}
        onClick={() => handleActionClick(action.onClick)}
        color={action.color || 'primary'}
        variant={action.variant || 'contained'}
      >
        {action.text}
      </Button>
    ))
  ) : (
    <Button onClick={onClose} color="primary" variant="contained">
      OK
    </Button>
  );

  return (
    <BaseDialog
      config={{ ...config, type: 'info' }}
      onClose={onClose}
      title={config.title}
      content={config.content}
      actions={dialogActions}
      showCloseButton
    />
  );
}
